export const logout = () => {
  sessionStorage.removeItem("sn-gestion-legal");

  // const VUELVE = "http://localhost:3000";
  const VUELVE = process.env.REACT_APP_VUELVE_URL || "https://stage--gestion-deudas.netlify.app";
  const REACT_APP_AUTH_URL = "https://wsrfa.sannicolasciudad.gob.ar/autenticar/deslogueo.php";

  return window.location.replace(`${REACT_APP_AUTH_URL}?fnt=afip&vlv=${VUELVE}`);
};
